<script lang="ts">
  import { getHref } from '../../helpers/sections-helper';
  import { BulletPoint } from '../../components/index';
  import { LeftArrow, RightArrow } from '../../components/icons';
  import './css/how-it-works.scss';
  import type { HowItWorks } from '../types';

  export let properties: HowItWorks;

  $: ({ button, callouts, description, headline, items, kicker } = properties);
</script>

<section class="how-it-works">
  <div class="wrapper">
    <div class="how-top">
      <p class="sub-title">{@html kicker?.value}</p>
      <h2 class="h2">{@html headline?.value}</h2>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="227"
        height="20"
        viewBox="0 0 227 20"
        fill="none"
      >
        <path
          d="M39.0414 15.5516C54.1046 11.0102 70.1937 8.76441 85.8495 10.6168C85.9155 10.6168 85.9788 10.643 86.0255 10.6897C86.0722 10.7364 86.0984 10.7998 86.0984 10.8658C86.0984 10.9318 86.0722 10.9952 86.0255 11.0418C85.9788 11.0885 85.9155 11.1148 85.8495 11.1148C70.1837 10.816 54.7271 13.3257 39.1509 16.0396C38.8522 16.0844 38.7576 15.6412 39.0414 15.5516Z"
          fill="var(--color-accent)"
        />
        <path
          d="M36.6317 16.9705C35.3599 17.3745 34.0407 17.6106 32.7078 17.6726C32.5953 17.6841 32.4823 17.657 32.3873 17.5957C32.2922 17.5345 32.2209 17.4427 32.185 17.3355C32.1491 17.2283 32.1507 17.1121 32.1896 17.0059C32.2285 16.8998 32.3024 16.81 32.399 16.7514C33.643 16.0258 35.1027 15.7614 36.5221 16.0045C36.6348 16.0164 36.74 16.0664 36.8205 16.1463C36.9009 16.2261 36.9517 16.331 36.9644 16.4435C36.9772 16.5561 36.9512 16.6697 36.8907 16.7655C36.8302 16.8613 36.7388 16.9336 36.6317 16.9705Z"
          fill="var(--color-accent)"
        />
        <path
          d="M192.806 7.9973C172.888 5.88098 152.671 4.1182 132.732 6.79223C120.323 -10.1383 23.2414 9.21231 0.937823 14.9787C0.800379 15.0139 0.680529 15.0981 0.600765 15.2155C0.521001 15.3328 0.486808 15.4753 0.5046 15.616C0.509175 15.6586 0.522688 15.6997 0.544255 15.7366C0.565821 15.7736 0.594954 15.8056 0.629745 15.8305C0.664535 15.8554 0.704196 15.8727 0.746132 15.8812C0.788069 15.8898 0.831332 15.8893 0.873088 15.88C25.771 10.2182 110.03 -4.89482 129.346 7.35493C124.287 8.50521 116.21 10.4323 115.209 14.152C114.124 18.1755 117.39 20.5558 120.637 19.8885C126.03 19.291 132.09 16.3182 133.395 10.6116C164.119 7.39975 194.942 11.3834 225.711 13.8433C225.749 13.846 225.787 13.8412 225.823 13.8291C225.859 13.8171 225.893 13.798 225.921 13.773C225.95 13.748 225.974 13.7176 225.99 13.6835C226.007 13.6495 226.017 13.6124 226.02 13.5744C226.029 13.4174 225.98 13.2625 225.883 13.1388C225.786 13.0151 225.647 12.931 225.492 12.9022C214.67 10.8937 203.774 9.25879 192.806 7.9973ZM129.77 11.4531C127.778 14.401 123.5 16.4327 119.81 16.4327C118.476 16.4327 118.456 15.8152 118.75 15.4965C121.24 12.7627 126.443 11.9859 129.959 11.1693C129.884 11.249 129.829 11.3535 129.77 11.4531Z"
          fill="var(--color-accent)"
        />
      </svg>
      <p class="sub-text">
        {@html description?.richText}
      </p>
    </div>

    <div class="how-it-works-boxes">
      {#each items as { title, text, image }, index (title.value)}
        <div class="how-box">
          <img src={image?.value} alt="icon-img" />
          {#if index === 1}
            <LeftArrow />
          {:else if index === 2}
            <RightArrow />
          {/if}
          <div class="how-content">
            <h3 class="h3">{@html title?.value}</h3>
            <p class="text">
              {@html text?.value}
            </p>
          </div>
        </div>
      {/each}
    </div>
    {#if button?.label?.length}
      <div class="bottom-boxes">
        <a
          id="how-book-now"
          target={button.link_type === 'External' ? '_blank' : ''}
          class="primary-button open-form-js"
          href={getHref(button.link_type, button.link)}>{@html button.label}</a
        >

        <div class="small-text-box">
          {#each callouts?.value as text}
            <div>
              <BulletPoint bulletIcon={callouts?.icon} />
              <p class="text-small">{@html text}</p>
            </div>
          {/each}
        </div>
      </div>
    {/if}
  </div>
</section>
